<template>
  <div class="page-container">
    <NavBarAdmin />
    <div class="loader" id="requestLoader">
      <span class="helper" id="requestHelper"></span>
      <div id="requestTrans">
        <img src="../../img/loader.gif" /><br />
        <a id="requestLink" target="_blank">Track your transaction</a>
      </div>
      <div id="dbLoading">
        <img src="../../img/loader.gif" /><br />
        <div>Saving your transaction</div>
      </div>
    </div>
    <div class="page-container-inner-wrapper">
      <div class="list row">
        <h3 class="table-headline">New request</h3>
        <div class="page-content-wrapper">
          <div class="page-bubble" v-if="!submitted">
            <h3 class="table-headline">Fill out form to register request</h3>
            <input
              type="hidden"
              v-model="request.companyCode"
              placeholder="companyCode"
              readonly
            />
            <input
              type="hidden"
              v-model="request.requestCode"
              placeholder="requestCode"
              readonly
            />
            <label for="location">Location</label>
            <select
              v-model="request.locationCode"
              placeholder="Location Code"
              id="rCity"
            >
            <option
                v-for="location in locations"
                :value="location.locationCode"
                v-bind:key="location.locationCode"
              >{{ location.locationName }}</option>

              <!-- <option value="073">Blagoevgrad</option>
              <option value="078">Kyustendil</option>
              <option value="096">Montana</option>
              <option value="068">Lovech</option>
              <option value="076">Pernik</option>
              <option value="064">Pleven</option>
              <option value="720">Sofia</option>
              <option value="002">Sofia-City</option>
              <option value="094">Vidin</option>
              <option value="092">Vratsa</option> -->
            </select>
            <label for="when">When</label>
            <select v-model="request.dayType" placeholder="When" id="rWhen">
              <option value disabled>Select a day type</option>
              <option value="weekdays">weekdays</option>
              <option value="weekends">weekends</option>
              <option value="alldays">alldays</option>
            </select>
            <label for="dateFrom">Date from</label>
            <input
              type="date"
              v-model="request.dateFrom"
              placeholder="Date from"
              id="rdateFrom"
            />
            <label for="dateTo">Date to</label>
            <input
              type="date"
              v-model="request.dateTo"
              placeholder="Date to"
              id="rdateTo"
            />
            <label for="timeFrom">Time from</label>
            <input
              type="time"
              v-model="request.timeFrom"
              placeholder="Time from"
              id="rtimeFrom"
            />
            <label for="timeTo">Time to</label>
            <input
              type="time"
              v-model="request.timeTo"
              placeholder="Time to"
              id="rtimeTo"
            />
            <label for="volume">Volume (KWh)</label>
            <input type="text" v-model="request.volume" id="rVolume" />
            <label for="price">Price (&euro;/KWh)</label>
            <input type="text" v-model="request.price" id="rPrice" />
            <label for="deadline">Deadline</label>
            <input
              type="date"
              v-model="request.deadline"
              placeholder="Deadline"
            />
            <button class="request-button" @click="saveRequest">Save</button>
          </div>
          <div class="page-bubble" v-if="submitted">
            <h4>You submitted successfully!</h4>
            <button class="btn btn-success" @click="newRequest">Add</button>
          </div>
          <div class="page-bubble page-upload-wrapper">
            <form enctype="multipart/form-data">
              <h3 class="table-headline">Upload requests from Excel file.</h3>
              <input type="file" name="file" class="file-button" />
              <button class="request-button" v-on:click="importRequests">
                Import
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LocationDataService from "../../services/LocationDataService";
import RequestDataService from "../../services/RequestDataService";
import NavBarAdmin from "../../components/Common/NavBarAdmin";

export default {
  name: "add-request",
  components: { NavBarAdmin },
  data() {
    return {
      request: {
        id: null,
        companyCode: this.$store.state.auth.user.companyCode,
        requestCode: "",
        locationCode: "",
        dayType: "",
        dateFrom: "",
        dateTo: "",
        timeFrom: "",
        timeTo: "",
        volume: "",
        price: "",
        deadline: "",
      },
      submitted: false,

      locations: [],
      countryCode: this.$store.state.auth.user.countryCode,
    };
  },
  methods: {

    retrieveLocations(countryCode) {
      LocationDataService.findBySubCountryCode(countryCode)
        .then((response) => {
          this.locations = response.data;
          console.log("HERE... load locations sucessfull: " + response.data);
        })
        .catch((e) => {
          console.log("HERE... load locations zones error: " + e);
        });
    },

    async saveRequest() {
      var data = {
        companyCode: this.request.companyCode,
        requestCode: this.request.requestCode,
        locationCode: this.request.locationCode,
        dayType: this.request.dayType,
        dateFrom: this.request.dateFrom,
        dateTo: this.request.dateTo,
        timeFrom: this.request.timeFrom,
        timeTo: this.request.timeTo,
        volume: this.request.volume,
        price: this.request.price,
        deadline: this.request.deadline,
      };
      await this.Apps.registerRequest();
      if (await this.savedToBlock) {
        document.getElementById("requestLoader").style.display = "block";
        document.getElementById("dbLoading").style.display = "inline-block";
        RequestDataService.create(data)
          .then((response) => {
            this.request.id = response.data.id;
            document.getElementById("requestLoader").style.display = "none";
            document.getElementById("dbLoading").style.display = "none";
            console.log(response.data);
            this.submitted = true;
            this.$router.push({ name: "requestsAdmin" });
          })
          .catch((e) => {
            console.log(e);
          });
      }
    },

    importRequests() {
      var data = {
        companyCode: this.request.companyCode,
        requestCode: this.request.requestCode,
        locationCode: this.request.locationCode,
        dateFrom: this.request.dateFrom,
        dateTo: this.request.dateTo,
        timeFrom: this.request.timeFrom,
        timeTo: this.request.timeTo,
        volume: this.request.volume,
        price: this.request.price,
        deadline: this.request.deadline,
      };

      RequestDataService.import(data)
        .then((response) => {
          this.request.id = response.data.id;
          console.log(response.data);
          this.submitted = true;
          this.$router.push({ name: "requests" });
        })
        .catch((e) => {
          console.log(e);
        });
    },

    newRequest() {
      this.submitted = false;
      this.request = {};
    },
  },

  computed: {
    savedToBlock() {
      return this.$store.getters.savedToBlock;
    },
  },

  mounted: function () {
    this.$store.state.auth.user;
    this.retrieveLocations(this.$store.state.auth.user.countryCode);
    this.$nextTick(function () {
      
      //  this.filterOffers();
      // Code that will run only after the entire view has been rendered
    });
  },
};
</script>

<style lang="scss">
@import "../../sass/main.scss";

.nav-bar {
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);
  margin-top: -100px;
  margin-left: -10px;
}

.page-container {
  min-height: 100vh;
  background: #e6e8f0;
}

.page-container-inner-wrapper {
  padding: 40px;
  max-width: 1300px;
  margin: 0 auto;
}

.page-content-wrapper {
  width: 100%;
  display: flex;
}

.page-bubble {
  box-shadow: 0 4px 6px 0 hsla(0, 0, 0, 0.2);
  background: #fff;
  padding: 40px;
  width: 40%;
  margin-right: 40px;
  overflow-x: hidden;
}

.page-upload-wrapper {
  width: 35% !important;
  height: 225px;
}

.page-bubble label {
  display: block;
  font-size: 0.9em;
  margin: 0 0 3px 5px;
}

.page-bubble input,
.page-bubble select {
  width: 100%;
  padding: 6px 10px;
  border-radius: 10px;
  border: 1px solid #ccc;
  margin-bottom: 20px;
}

// input::-webkit-calendar-picker-indicator {
//   color: rgba(0, 0, 0, 0) !important;
// }

.page-bubble input:focus,
.page-bubble select:focus {
  outline: none;
  border: 1px solid #6680a0;
  box-shadow: 0 0 5px #c8d2da;
}

.file-button {
  border: none !important;
  padding: 0 !important;
  border-radius: 0 !important;
  margin-bottom: 0 !important;
  font-size: 0.9rem;
  color: #393b3e;
  padding: 5px 15px;
  background: #fff;
  cursor: pointer;
}

.submit-form {
  max-width: 400px;
  margin: auto;
}

.request-button {
  padding: 5px 15px;
  border: none;
  font-size: 1rem;
  color: white;
  background: #146bd4;
  margin-top: 20px;
}
.loader {
  background: rgba(0, 0, 0, 0.4);
  display: none;
  height: 100%;
  position: fixed;
  text-align: center;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.loader .requestHelper {
  display: none;
  height: 40%;
  vertical-align: middle;
}
.loader > div {
  background-color: #fff;
  box-shadow: 10px 10px 60px #555;
  display: none;
  width: 20%;
  position: fixed;
  border-radius: 8px;
  padding: 15px 5%;
  margin-top: 19%;
  margin-left: -10%;
}

.requestLink:hover {
  text-decoration: underline;
}
</style>
